export class Settings {
    briefingValidityTime: number;
    sendEmail: string;
    heading1: string;
    heading2: string;
    text: string;
}
